import { useState } from 'react'

import { useTheme } from 'styled-components'

import {
  heatMapOptions,
  infoTypes,
  viewInfoTypes,
} from '@/metrics/pages/DashboardPage/ShipmentsMetricsContent/constants'

import { getCountryCodeByRegionId, getHeatMapMetrics } from './helpers'

const useGeneralMetrics = ({ regions, setCommonFilters, commonFilters, countriesMetrics }) => {
  const theme = useTheme()
  const [viewType, setViewType] = useState(viewInfoTypes.map)
  const [infoType, setInfoType] = useState(infoTypes.global)
  const [orderBy, setOrderBy] = useState(heatMapOptions.totalOrdersCount)

  const getRegionIdByCountryCode = countryCode => {
    const region = regions.find(region => region.code === countryCode)

    return region?.id
  }

  const onChangeCountry = countryCode => {
    setViewType(viewInfoTypes.map)

    const countryCodeSelected = getCountryCodeByRegionId(regions, commonFilters.regionId)

    if ((countryCode === countryCodeSelected && viewType === viewInfoTypes.map) || !countryCode) {
      setInfoType(infoTypes.global)
      setCommonFilters(filters => ({ ...filters, regionId: 'all' }))
    } else {
      const regionId = getRegionIdByCountryCode(countryCode)

      if (regionId) {
        setInfoType(infoTypes.country)
        setCommonFilters(filters => ({ ...filters, regionId: regionId }))
      }
    }
  }

  const onChangeViewType = type => {
    setCommonFilters(filters => ({ ...filters, regionId: 'all' }))
    if (type === viewInfoTypes.map) {
      setViewType(viewInfoTypes.map)
      setInfoType(infoTypes.global)
    } else if (type === viewInfoTypes.list) {
      setViewType(viewInfoTypes.list)
    }
  }

  const onChangeOrderBy = value => {
    setOrderBy(value)
  }

  return {
    infoType,
    setInfoType,
    onChangeCountry,
    viewType,
    setViewType,
    onChangeViewType,
    getRegionIdByCountryCode,
    orderBy,
    setOrderBy,
    heatMapMetrics: getHeatMapMetrics(countriesMetrics, orderBy, theme),
    onChangeOrderBy,
  }
}

export default useGeneralMetrics
